export { default } from "./InputError";
